// Impresión directa de tickets (80mm) vía GestiónAudio Desktop (Electron).
// En navegador no hay impresión silenciosa: se abre el PDF como hasta ahora.

export const TICKET_PRINTER_KEY = "gestionaudio_ticket_printer";

export function isDesktop() {
  return typeof window !== "undefined" && !!window.audiocenterDesktop?.isDesktop;
}

export function getSavedPrinter() {
  try {
    return localStorage.getItem(TICKET_PRINTER_KEY) || "";
  } catch {
    return "";
  }
}

export function savePrinter(name) {
  try {
    if (name) localStorage.setItem(TICKET_PRINTER_KEY, name);
    else localStorage.removeItem(TICKET_PRINTER_KEY);
  } catch {
    /* ignore */
  }
}

export async function listPrinters() {
  if (!window.audiocenterDesktop?.listPrinters) return null;
  return await window.audiocenterDesktop.listPrinters();
}

// Devuelve true si el ticket se envió a la impresora configurada.
// Devuelve false si no hay impresora/desktop (el llamador abre el PDF).
// Lanza Error si la impresión falló.
export async function printTicketBlob(blob) {
  const printer = getSavedPrinter();
  if (!printer || !window.audiocenterDesktop?.printPdf) return false;
  const buf = await blob.arrayBuffer();
  const bytes = new Uint8Array(buf);
  let binary = "";
  for (let i = 0; i < bytes.length; i += 0x8000) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  }
  const res = await window.audiocenterDesktop.printPdf(btoa(binary), printer);
  if (res?.ok) return true;
  throw new Error(res?.error || "Fallo de impresión");
}
